(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("fp4AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $be9f2b2a8c843571$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $cT9vQ = parcelRequire("cT9vQ");

var $4yYSq = parcelRequire("4yYSq");

var $dTCkE = parcelRequire("dTCkE");

var $9LXOV = parcelRequire("9LXOV");

var $7mYvk = parcelRequire("7mYvk");

const $be9f2b2a8c843571$var$BrokerReviews = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("iN5yi")));

const $be9f2b2a8c843571$var$ContactForm = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("a3GHK")));

const $be9f2b2a8c843571$var$BrokerObjects = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("eHmdc")));

const $be9f2b2a8c843571$var$BrokerSoldObjects = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("5TaiU")));

const $be9f2b2a8c843571$var$BlockList = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("hvnG1")));
const $be9f2b2a8c843571$var$BrokerProfilePageNew = ({ brokerQuery: brokerQuery })=>{
    const { officeAdminPage: officeAdminPage, office: office } = (0, $dTCkE.useContext)((0, $9LXOV.OfficePageContext));
    const isCommercial = office?.properties?.isCommercial;
    const officeId = office?.properties?.officeId;
    const { data: broker } = (0, $cT9vQ.default)(brokerQuery, officeId);
    const { data: brokerSoldObjects, isLoading: isLoading } = (0, $4yYSq.default)(broker?.id, false, false, true);
    const { data: allBrokerEstatesForSale } = (0, $4yYSq.default)(broker?.id, true, true, false);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            broker?.reviews && broker?.reviews.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($be9f2b2a8c843571$var$BrokerReviews, {
                    broker: broker
                })
            }),
            broker?.hasEstates && allBrokerEstatesForSale && allBrokerEstatesForSale?.totalLength > 0 && broker?.id && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($be9f2b2a8c843571$var$BrokerObjects, {
                    brokerId: broker?.id,
                    allBrokerEstatesForSale: allBrokerEstatesForSale?.totalLength
                })
            }),
            brokerSoldObjects && brokerSoldObjects?.totalLength ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($be9f2b2a8c843571$var$BrokerSoldObjects, {
                    brokerId: broker?.id,
                    brokerEstateInfo: brokerSoldObjects,
                    isLoading: isLoading
                })
            }) : null,
            officeAdminPage?.properties?.showFormBroker && broker && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($be9f2b2a8c843571$var$ContactForm, {
                    officeAdminPage: officeAdminPage,
                    office: office,
                    broker: broker,
                    isBrokerForm: true
                })
            }),
            officeAdminPage?.properties?.brokerBlockList?.items && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($be9f2b2a8c843571$var$BlockList, {
                    blocks: officeAdminPage?.properties?.brokerBlockList?.items
                })
            }),
            !isCommercial && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "mx-auto max-w-container",
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7mYvk.BoneoImageBroker), {})
                })
            })
        ]
    });
};
var $be9f2b2a8c843571$export$2e2bcd8739ae039 = $be9f2b2a8c843571$var$BrokerProfilePageNew;

});
parcelRegister("cT9vQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f655482e800bd654$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $f655482e800bd654$var$useBroker = (name, officeId)=>{
    return (0, $4cyLg.useQuery)([
        "broker",
        officeId
    ], async ()=>{
        const response = await (0, $1HGFx.OfficeService).officeGetBroker(name, officeId);
        if (!response) throw new Error("Failed to fetch broker data");
        return response;
    }, {
        enabled: !!name && !!officeId
    } // Only run when both are available
    );
};
var $f655482e800bd654$export$2e2bcd8739ae039 = $f655482e800bd654$var$useBroker;

});

parcelRegister("4yYSq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383aca8ea09919a4$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $383aca8ea09919a4$var$useBrokerEstates = (brokerId, forSale, headStart, sold)=>{
    return (0, $4cyLg.useQuery)([
        "brokersEstates",
        brokerId,
        forSale,
        headStart,
        sold
    ], ()=>(0, $1HGFx.EstatesService).estatesGetEstatesForBroker(brokerId, forSale, headStart, sold).then((response)=>response), {
        enabled: forSale !== undefined || headStart !== undefined || sold !== undefined
    });
};
var $383aca8ea09919a4$export$2e2bcd8739ae039 = $383aca8ea09919a4$var$useBrokerEstates;

});

parcelRegister("9LXOV", function(module, exports) {

$parcel$export(module.exports, "SectionId", function () { return $c9ad3237bab4dff6$export$9bbe9bfd3294dd44; });
$parcel$export(module.exports, "OfficePageContext", function () { return $c9ad3237bab4dff6$export$c2c979cca401ee73; });
$parcel$export(module.exports, "default", function () { return $c9ad3237bab4dff6$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $gElZS = parcelRequire("gElZS");

var $bpgjK = parcelRequire("bpgjK");
var $c9ad3237bab4dff6$export$9bbe9bfd3294dd44;
(function(SectionId) {
    SectionId["Overview"] = "overview";
    SectionId["News"] = "news";
    SectionId["Objects"] = "objects";
    SectionId["Brokers"] = "brokers";
    SectionId["SoldObjects"] = "soldobjects";
    SectionId["Partners"] = "partners";
})($c9ad3237bab4dff6$export$9bbe9bfd3294dd44 || ($c9ad3237bab4dff6$export$9bbe9bfd3294dd44 = {}));
const $c9ad3237bab4dff6$export$c2c979cca401ee73 = /*#__PURE__*/ (0, $dTCkE.createContext)({});
const $c9ad3237bab4dff6$var$OfficePageContextProvider = ({ children: children, pageId: pageId, archiveId: archiveId })=>{
    const { data: officeAdminPage } = (0, $bpgjK.default)("BrokerPages", true);
    const { data: office } = (0, $gElZS.default)(pageId);
    const officePageContextObject = {
        office: office,
        officeAdminPage: officeAdminPage,
        archiveId: archiveId
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)($c9ad3237bab4dff6$export$c2c979cca401ee73.Provider, {
        value: officePageContextObject,
        children: children
    });
};
var $c9ad3237bab4dff6$export$2e2bcd8739ae039 = $c9ad3237bab4dff6$var$OfficePageContextProvider;

});
parcelRegister("gElZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ace35a6eaf6636e1$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");
const $ace35a6eaf6636e1$var$useUmbracoOffice = (pageId)=>{
    return (0, $4cyLg.useQuery)([
        "umbracoOffices",
        pageId
    ], ()=>fetch(`/umbraco/delivery/api/v2/content/item/${pageId}`).then((response)=>{
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        }), {
        enabled: !!pageId,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $ace35a6eaf6636e1$export$2e2bcd8739ae039 = $ace35a6eaf6636e1$var$useUmbracoOffice;

});

parcelRegister("bpgjK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b95939dcf85c40$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");
const $59b95939dcf85c40$var$umbracoContentType = (alias, takeFirst = false)=>{
    const takeFirstOccurance = takeFirst ? "&take=1" : "";
    return (0, $4cyLg.useQuery)([
        "umbracoContentType",
        alias
    ], ()=>fetch(`/umbraco/delivery/api/v2/content?filter=contentType:${alias}${takeFirstOccurance}`).then((response)=>{
            if (!response.ok) throw new Error("Network response was not ok");
            if (takeFirst) return response.json().then((data)=>data?.items?.[0]);
            return response.json();
        }), {
        enabled: !!alias,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $59b95939dcf85c40$export$2e2bcd8739ae039 = $59b95939dcf85c40$var$umbracoContentType;

});


parcelRegister("7mYvk", function(module, exports) {

$parcel$export(module.exports, "BoneoImageBroker", function () { return $5c1e76ce28f8731b$export$35e5a7740ab0fd1b; });

var $a9eYm = parcelRequire("a9eYm");

var $67EyS = parcelRequire("67EyS");
const $5c1e76ce28f8731b$export$35e5a7740ab0fd1b = ({ fullMargin: fullMargin })=>{
    const isBigScreen = (0, $67EyS.default)("(min-width: 47rem)");
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: `mb-6 lg:mb-16 lg:mt-8 max-w-7xl mx-auto overflow-hidden `,
            children: /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
                className: `${!fullMargin ? "mt-4" : ""} block max-w-full min-h-[195px]`,
                href: "https://www.boneo.se/?utm_source=lansfast&utm_medium=referral&utm_campaign=boneo-PaG",
                target: "_blank",
                children: [
                    isBigScreen === false && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        loading: "lazy",
                        className: `${!fullMargin ? "mt-4" : ""} w-full rounded-md`,
                        src: "/Images/boneo/boneo-phone.jpg?format=webp&quality=80",
                        alt: "Boneo",
                        width: 600,
                        height: 900
                    }),
                    isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        loading: "lazy",
                        className: "rounded-md w-full",
                        src: "/Images/boneo/boneo-desktop.jpg?format=webp&quality=80",
                        alt: "Boneo",
                        width: 1180,
                        height: 200
                    })
                ]
            })
        })
    });
};

});
parcelRegister("67EyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23722fec40a37891$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $23722fec40a37891$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $dTCkE.useState)();
    (0, $dTCkE.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>setMatches(media.matches);
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        query,
        matches
    ]);
    return matches;
};
var $23722fec40a37891$export$2e2bcd8739ae039 = $23722fec40a37891$var$useMediaQuery;

});


parcelRegister("iN5yi", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("zHfwy")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("T3MgL"))
]).then(()=>parcelRequire("1Eoh9"));

});

parcelRegister("a3GHK", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bop5H")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("1WDNe")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iG5lV")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("gg0Ro")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3H1xp")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7rgMa")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jc4ur")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6RYDG"))
]).then(()=>parcelRequire("7UOR6"));

});

parcelRegister("eHmdc", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("4WKMi"))((parcelRequire("i55FY")).resolve("7FDLX")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("zHfwy")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bIRMW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hL3yc"))
]).then(()=>parcelRequire("6EDyb"));

});

parcelRegister("5TaiU", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("4WKMi"))((parcelRequire("i55FY")).resolve("9Juef")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("zHfwy")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bIRMW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("34Mwh"))
]).then(()=>parcelRequire("7FEOv"));

});

parcelRegister("hvnG1", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("2ZL6u")).then(()=>parcelRequire("agtBJ"));

});


})();
//# sourceMappingURL=BrokerProfilePageNew.a8bedb4d.js.map
